import { render, staticRenderFns } from "./MspProdottoLista.vue?vue&type=template&id=650ca867"
import script from "./MspProdottoLista.vue?vue&type=script&lang=js"
export * from "./MspProdottoLista.vue?vue&type=script&lang=js"
import style0 from "./MspProdottoLista.vue?vue&type=style&index=0&id=650ca867&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports